import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

// Компонент для отображения состояния загрузки
function LoadingState() {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}
    >
      <CircularProgress />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Проверка авторизации...
      </Typography>
    </Box>
  );
}

function PrivateRoute() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const [loadingTimeout, setLoadingTimeout] = useState(false);

  // Устанавливаем таймаут для состояния загрузки (флаг cancelled — без setState после cleanup / размонтирования)
  useEffect(() => {
    if (!loading) {
      setLoadingTimeout(false);
      return undefined;
    }
    let cancelled = false;
    const timer = setTimeout(() => {
      if (!cancelled) {
        setLoadingTimeout(true);
      }
    }, 15000);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [loading]);

  useEffect(() => {
    if (loadingTimeout && !user) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
    }
  }, [loadingTimeout, user]);

  // Если превышен таймаут загрузки или (пользователь не авторизован и загрузка завершена),
  // перенаправляем на страницу входа
  if ((loadingTimeout && !user) || (!user && !loading)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Показываем индикатор загрузки только если загрузка активна и пользователь не авторизован
  if (loading && !user) {
    return <LoadingState />;
  }

  // Пока must_change_password — только /change-password (и выход со страницы смены пароля)
  if (user?.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  // Если пользователь авторизован или загрузка еще идет, но у нас есть данные пользователя,
  // рендерим дочерние компоненты
  return <Outlet />;
}

export default PrivateRoute;